module.exports = __webpack_public_path__ + "static/flags/HK-0c960008e7eba8c286259e904acfcc2b.gif";